import { render, staticRenderFns } from "./mblacklist.vue?vue&type=template&id=3e185f79&scoped=true"
import script from "./mblacklist.vue?vue&type=script&lang=js"
export * from "./mblacklist.vue?vue&type=script&lang=js"
import style0 from "./mblacklist.vue?vue&type=style&index=0&id=3e185f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e185f79",
  null
  
)

export default component.exports